<template>
    <div class="flex flex-1 gap-x-8 px-8 mb-4">
        <jet-nav-link
            :href="route('customers.setup', customer.id)"
            :active="route().current('customers.setup')"
            :class="{ 'active': route().current('customers.setup') }"
            class="text-base subnav"
        >
            Setup
        </jet-nav-link>

        <jet-nav-link
            v-if="showProfile"
            :href="route('customers.edit', customer.id)"
            :active="route().current('customers.edit')"
            :class="{ 'active': route().current('customers.edit') }"
            class="text-base subnav"
        >Profile</jet-nav-link>

        <jet-nav-link
            v-if="showOrderHistory"
            :href="route('customers.history', customer.id)"
            :active="route().current('customers.history')"
            :class="{ 'active': route().current('customers.history') }"
            class="text-base subnav"
        >Order History</jet-nav-link>

        <jet-nav-link
            :href="route('customers.users.index', customer.id)"
            :active="route().current('customers.users.index')"
            :class="{ 'active': route().current('customers.users.index') }"
            class="text-base subnav"
        >Users</jet-nav-link>

        <jet-nav-link 
            v-if="isAdmin"
            :href="route('customers.uploads.index', customer.id)"
            :active="route().current('customers.uploads.index')"
            :class="{ 'active': route().current('customers.uploads.index') }"
            class="text-base subnav"
        >Uploads</jet-nav-link>

        <jet-nav-link
            v-if="showCreditCardTab"
            :href="route('customers.card_vault', customer.id)"
            :active="route().current('customers.card_vault')"
            :class="{ 'active': route().current('customers.card_vault') }"
            class="text-base subnav"
        >Credit Card</jet-nav-link>
    </div>
</template>

<script>
import { usePage } from '@inertiajs/inertia-vue3'
import JetNavLink from '@/Jetstream/NavLink';
import UseUserAuth from '@/Composables/UseUserAuth';

export default {
    setup () {
        const { isAdmin } = UseUserAuth(usePage().props.value.user);

        return {
            isAdmin,
        }
    },

    components: {
        JetNavLink,
    },

    props: ['customer'],

    computed: {
        showProfile() {
            if (this.customer?.onboarding_status === 'activated') {
                return true
            }
            if (this.customer?.onboarding?.status === 'payment_details_approved') {
                return true
            }
            if (this.isAdmin && this.customer?.onboarding_status !== 'activated') {
                return true
            }
            return false
        },
        showOrderHistory() {
            return this.customer?.onboarding_status === 'activated'
                || this.customer?.onboarding?.status === 'payment_details_approved'
        },
        showCreditCardTab() {
            if (!this.isAdmin) return false
            if (this.customer?.onboarding_status === 'activated') return true
            return this.customer?.vault != null
        },
    },
}
</script>

<style scoped>
.subnav {
    @apply border-white border-b-2 hover:border-red-dark font-semibold;
}
.subnav.active {
    @apply border-b-2 border-red-dark font-bold;
}
</style>